<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>{{isApprove ? 'Approvazione' : 'Rifiuto'}} Arruolamento Paziente</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onClose()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="ion-margin">
    <ion-row>
      <ion-col>
        <ion-text>
          <h3>1. Codice fiscale del paziente</h3>
        </ion-text>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item>
          <ion-label position="floating">Codice Fiscale</ion-label>
          <ion-input disabled type="text" [(ngModel)]="patientData.patientFiscalCode"></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-text>
          <h3>2. Note dello specialista</h3>
        </ion-text>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-text class="ion-text-justify">
          <ion-note>
            <p class="ion-text-justify">
              Specificare eventuali note relative {{isApprove ? 'all\'approvazione' : 'al rifiuto'}} dell'arruolamento
              del paziente.
            </p>
          </ion-note>
        </ion-text>
        <ion-item>
          <ion-textarea rows="6" placeholder="Inserisci qui le tue note" [(ngModel)]="specialistNotes"></ion-textarea>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="danger" (click)="onClose()">Annulla</ion-button>
      <ion-button color="primary" (click)="saveAction()">
        <ng-container>
          <span>Salva</span>
          <ion-icon slot="end" [src]="'content-save' | getIcon"></ion-icon>
        </ng-container>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>